/* theme.js — Todo Naturista — v6 click directo */

document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE MENU ──────────────────────────────
  var toggle = document.querySelector('.header__mobile-toggle');
  var mobileNav = document.querySelector('.header__mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // ── CART COUNT ───────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, justAdded: true } }));
      })
      .catch(function() {});
  }

  updateCartCount();

  // ── ADD TO CART — escuchar CLICK no submit ────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-card__add-btn, .product-page__add-btn');
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();

    var form = btn.closest('form');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    var orig = btn.textContent.trim();
    btn.textContent = 'Agregando...';
    btn.style.background = '#085041';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(idInput.value), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      updateCartCount();
      btn.textContent = '¡Agregado! ✓';
      btn.style.background = '#1DAB87';
      setTimeout(function() {
        btn.textContent = orig;
        btn.style.background = '';
      }, 1500);
    })
    .catch(function() {
      btn.textContent = orig;
      btn.style.background = '';
    });
  });

  // ── SORT ──────────────────────────────────────
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ── SEARCH TAGS ───────────────────────────────
  document.querySelectorAll('.search-tag').forEach(function (tag) {
    tag.addEventListener('click', function (e) {
      e.preventDefault();
      var input = document.querySelector('.search-bar__input');
      if (input) {
        input.value = tag.textContent.trim();
        if (input.form) input.form.submit();
      }
    });
  });

});
